import { supabase } from '@/integrations/supabase/client';

export const generateSlug = (title: string): string => {
  return title
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[*+~.()'"!:@]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const validateSlugUnique = async (
  slug: string,
  table: 'blog_posts' | 'support_docs',
  excludeId?: string
): Promise<{ isUnique: boolean; suggestedSlug?: string }> => {
  let query = supabase
    .from(table)
    .select('id, slug')
    .eq('slug', slug);

  if (excludeId) {
    query = query.neq('id', excludeId);
  }

  const { data, error } = await query;

  if (error) {
    console.error('Error checking slug uniqueness:', error);
    return { isUnique: false };
  }

  if (!data || data.length === 0) {
    return { isUnique: true };
  }

  // Generate alternative slug
  let counter = 2;
  let suggestedSlug = `${slug}-${counter}`;
  
  while (true) {
    let checkQuery = supabase
      .from(table)
      .select('id')
      .eq('slug', suggestedSlug);
    
    if (excludeId) {
      checkQuery = checkQuery.neq('id', excludeId);
    }

    const { data: checkData } = await checkQuery;
    
    if (!checkData || checkData.length === 0) {
      break;
    }
    
    counter++;
    suggestedSlug = `${slug}-${counter}`;
  }

  return { isUnique: false, suggestedSlug };
};
